import { yupResolver } from "@hookform/resolvers/yup";
import { getJobRelatedExpenseFieldsYupOnSubmitSchema } from "entities/JobRelatedExpense";
import * as yup from "yup";

export function getCardCostLineOnSubmitValidationSchema(cardFormat) {
  const jobRelatedExpenseSchema = getJobRelatedExpenseFieldsYupOnSubmitSchema();
  return yupResolver(
    yup.object().shape({
      ...jobRelatedExpenseSchema,
      attachments: yup.array().of(yup.number()),
      amount: yup
        .string()
        .required("Amount field is required")
        .matches(/^[\d .-]+/, "Amount must be a number")
        .matches(
          /^([\d -]+(?:[.,]\d{1,999})?)$/,
          "Add fractional number after decimal point or comma"
        )
        .matches(
          /^([\d -]+(?:[.,]\d{1,2})?)$/,
          "No more than two digits after decimal separator are allowed"
        ),
      comment: yup.string(),
      cost_type: yup
        .mixed()
        .test("cost_type", "Cost type field is required", (obj) => {
          return typeof obj?.value.id === "number";
        }),
      posting_entity: yup
        .string()
        .when((_, schema) =>
          cardFormat === "corporate" ? schema.nullable() : schema
        ),
      vat: yup
        .object({ label: yup.string(), value: yup.number() })
        .when(["is_job_related"], (isJobRelated, schema) =>
          // Remove retarded cardFormat prop and validate based on request type
          schema.nullable(cardFormat === "us/ca" || isJobRelated)
        )
        .typeError("Vat is required"),
      posting_gl_code: yup.mixed().when((_, schema) =>
        cardFormat === "corporate"
          ? schema.nullable()
          : schema.test("gl-number", "GL number is required", (obj) => {
              return (
                typeof obj?.value === "string" &&
                // TEA2-2202: for unknown reason values such as below are returned from API when GL code was not delivered
                obj?.value !== "GL - choose option"
              );
            })
      ),
    })
  );
}
